
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"9","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#002E6B","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 7.69c0-.337.129-.673.388-.93l5.601-5.54a1.308 1.308 0 1 1 1.842 1.86L2.229 8.622A1.308 1.308 0 0 1 0 7.691"}}),_c('path',{attrs:{"d":"M5.601 2.15a1.31 1.31 0 0 1 2.235-.926l5.54 5.54a1.31 1.31 0 0 1-1.852 1.852l-5.54-5.54a1.31 1.31 0 0 1-.383-.925"}})])])
          )
        }
      }
    